import { useEffect, useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { Modal, Progress } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'
import { Navigate } from 'react-router-dom'
import { getTranslate } from '../Language/Translate'

const t = (k, fb) => { const v = getTranslate(k); return (v && v !== k) ? v : fb }

// Hareketsizlik (idle) süresi ve uyarı penceresi. İstenirse buradan değiştirilir.
const TIMEOUT = 6000_000     // 2 saat işlem yoksa logout
const PROMPT = 300_000       // logout'tan 5 dk önce uyarı penceresi

/**
 * Oturum zaman aşımı — TIMEOUT kadar işlem yapılmazsa /Logout'a gider.
 * PROMPT kadar kala "devam et / çıkış" uyarı penceresi gösterir (geri sayımlı).
 * crossTab: tüm sekmeler senkron; bir sekmede çıkış → hepsi çıkar.
 */
export default function SessionTimeout() {
    const [open, setOpen] = useState(false)
    const [logout, setLogout] = useState(false)
    const [remaining, setRemaining] = useState(Math.ceil(PROMPT / 1000))

    const { getRemainingTime, activate, message } = useIdleTimer({
        timeout: TIMEOUT,
        promptBeforeIdle: PROMPT,
        throttle: 500,
        crossTab: true,
        leaderElection: true,
        syncTimers: 200,
        onIdle: () => setLogout(true),                 // süre doldu → çıkış
        onMessage: (e) => { if (e === 'logout') setLogout(true) },
    })

    // Kalan süreyi SÜREKLİ yokla → prompt penceresine girince uyarıyı aç (onPrompt'a/leader'a bağlı değil;
    // getRemainingTime crossTab senkron → her sekmede uyarı görünür). Tekrar aktif olunca otomatik kapanır.
    useEffect(() => {
        const id = setInterval(() => {
            const ms = getRemainingTime()
            setRemaining(Math.max(0, Math.ceil(ms / 1000)))
            setOpen(ms > 0 && ms <= PROMPT)
        }, 1000)
        return () => clearInterval(id)
    }, [getRemainingTime])

    const stay = () => { activate(); setOpen(false) }                       // devam et → sayaç sıfırlanır
    const leave = () => { setLogout(true); message('logout', true) }        // çıkış (tüm sekmelere yayınla)

    if (logout) {
        return <Navigate to='/Logout' />
    }

    const mm = String(Math.floor(remaining / 60)).padStart(2, '0')
    const ss = String(remaining % 60).padStart(2, '0')

    return (
        <Modal
            open={open}
            onOk={stay}
            onCancel={leave}
            maskClosable={false}
            closeIcon={false}
            centered
            okText={t('_continue_working_', 'Continue working')}
            cancelText={t('_logout_now_', 'Logout now')}
            cancelButtonProps={{ danger: true }}
            title={<span><ClockCircleOutlined style={{ color: '#d83a1a', marginRight: 8 }} />{t('_session_expiring_title_', 'Your session is about to expire')}</span>}
        >
            <div style={{ textAlign: 'center', padding: '10px 0 4px' }}>
                <Progress
                    type='circle'
                    percent={Math.round((remaining / (PROMPT / 1000)) * 100)}
                    format={() => `${mm}:${ss}`}
                    strokeColor={remaining <= 60 ? '#d83a1a' : '#6418c9'}
                    size={120}
                />
                <p style={{ margin: '18px 0 0', color: '#5b5366', fontSize: 14, lineHeight: 1.6 }}>
                    {t('_session_expiring_sub_', 'You have been inactive for a while. For your security, you will be logged out soon. Press “Continue working” to stay signed in.')}
                </p>
            </div>
        </Modal>
    )
}
